import './styles.sass'
import { MessageHTML } from '@/components/commons/MessageHTML'

export function NotificationMessageBody ({ text, html }) {
  if (text.trim().length === 0) { return (<></>) }

  return <section className="NotificationSectionMessage">
    <div className="notification-message-section-text">
      <MessageHTML html={html}/>
    </div>
  </section>
}
